module.exports = __webpack_public_path__ + "img/ics_o_flight-land.a21c75e0.svg";